import coupons from "./coupons";
import smartPromotions from "./smartPromotions";
let tr;
export default tr = {
  ...coupons,
  ...smartPromotions,
  Promotions: "العروض",
  Quantity: "الكمية",
  Remaining: "المتبقى",
  "Status has been toggled successfully": "تم تغير الحالة بنجاح",
  "The code already exists": "الكود مستخدم في عرض اخر",
  "English Description": "الوصف بالإنجليزي",
  "Arabic Description": "الوصف بالعربي",
  Update: "تحديث",
  Description: "الوصف",
  "New Expiry Date": "تاريخ الإنتهاء الجديد",
  "Extra Quantity": "الكمية اللإضافية",
  Extend: "تمديد",
  "Please choose the date range for qualified orders":
    "تحديد الفترة للطلبات المؤهلة للسحب",
  Raffle: "السحب",
  "WE HAVE A WINNER!": "لدينا رابح!",
  Manage: "تحكم",
  "Pick a Date Range for Orders": "تحديد الفترة الزمنية للطلبات",
  "Enter a number of copies": "ادخل عدد النسخ",
  "How many do you want?": "كم نسخة تريد؟",
  "Optional Additions:": "أضافات إختيارية:",
  Phone: "تلفون",
  Address: "العنوان",
  Instagram: "إنستاغرام",
  "Instagram as QR": "إنستاغرام شكل QR",
  "Website as QR": "الموقع شكل QR",
  from: "من",
  "Orders from ": "يطلب من ",

  "Loyalty Program": "برنامج المكافئات",
  "Enable Wallet": "تفعيل المحفظة",
  "Enable Loyalty Points": "تفعيل نقاط المكافئات",
  "Duplicate promotion?": "تكرار العرض؟",
  "Promotions are being created": "يتم إضافة العروض",
  "Number of promotions": "عدد العروض",
  "Customers get": "يحصل العملاء على",
  "points when they sign up": "نقاط عند التسجيل",
  "Enable Loyalty Points as a payment method": "تفعيل نقاط الولاء كطريقة دفع",
  "points can be redeemed for": "نفطة يمكن إستبدالها مقابل",
  Every: "كل",
  per: "لكل",
  "Maximum number of users is 1000": "الحد الأقصى للمستخدمين هو 1000",
  "show details": "عرض التفاصيل",
  "hide details": "إخفاء التفاصيل",
  "Created By": "انشأ من قبل",
  "1 Month": "1 شهر",
  "3 Months": "3 شهور",
  "6 Months": "6 شهور",
  "9 Months": " 9 شهور",
  "1 Year": "1 سنة",
  "Expire Loyalty Points After": "إلغاء صلاحية النقاط بعد",
  "No Expiry": "بدون فترة إلغاء",
  "Minimum spent": "الحد الادنى للطلب",

  "Ahli United Bank – Kuwait": "البنك الأهلي المتحد – الكويت",
  "Al Ahli Bank of Kuwait (ABK)": "البنك الأهلي الكويتي (ABK)",
  "Bank Muscat": "بنك مسقط",
  "Bank of Bahrain and Kuwait (BBK)": "بنك البحرين والكويت (BBK)",
  "Banque Nationale de Paris (BNP Paribas)": "بنك باريس الوطني (BNP Paribas)",
  "Boubyan Bank": "بنك بوبيان",
  "Burgan Bank": "بنك برقان",
  "Citibank N.A.": "سيتي بنك",
  "Commercial Bank of Kuwait (CBK)": "البنك التجاري الكويتي (CBK)",
  "Gulf Bank (GBK)": "بنك الخليج (GBK)",
  "HSBC Bank Middle East": "بنك HSBC الشرق الأوسط",
  "Industrial and Commercial Bank of China (ICBC)":
    "البنك الصناعي والتجاري الصيني (ICBC)",
  "Kuwait Finance House (KFH)": "بيت التمويل الكويتي (KFH)",
  "Kuwait International Bank (KIB)": "بنك الكويت الدولي (KIB)",
  "National Bank of Kuwait (NBK)": "بنك الكويت الوطني (NBK)",
  "Qatar National Bank (QNB)": "بنك قطر الوطني (QNB)",
  "Warba Bank": "بنك وربة",
  "Paying using a specific card's scheme": "الدفع باستخدام شبكة بطاقات معينة",
  "Paying using a specific bank's card": "الدفع باستخدام بطاقة من بنك معين",
  Visa: "فيزا",
  Mastercard: "ماستركارد",
  "Pays using": "يدفع باستخدام",
  "Register for the first time": "التسجيل لأول مرة",
  "Select a Scheme": "اختر الشبكة",
  "Select a Bank": "اختر البنك",
  "Pays using a card from": "يدفع باستخدام بطاقة من",
};
